import React from 'react';
import { ProFormItem } from '@ant-design/pro-components';
import SlugInput from '../SlugInput';

interface ProFormSlugInputProps {
    name: string;
    label?: string;
    tooltip?: string;
    rules?: any[];
    brandName?: string;
    disabled?: boolean;
    placeholder?: string;
    colProps?: any;
}

const ProFormSlugInput: React.FC<ProFormSlugInputProps> = ({
    name,
    label,
    tooltip,
    rules = [],
    brandName = '',
    disabled = false,
    placeholder = 'Sẽ tự động tạo từ tên thương hiệu',
    colProps,
    ...rest
}) => {
    return (
        <ProFormItem
            name={name}
            label={label}
            tooltip={tooltip}
            rules={rules}
            {...rest}
        >
            <SlugInput
                brandName={brandName}
                disabled={disabled}
                placeholder={placeholder}
            />
        </ProFormItem>
    );
};

export default ProFormSlugInput;
